import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tenantSelect", "agencyOptions", "agencyGroup", "agencySelect"]

  connect() {
    this.changeTenant()
  }

  changeTenant() {
    const tenantId = this.tenantSelectTarget.value

    const optionsTemplate = this.agencyOptionsTargets.find(template => {
      return template.dataset.tenantId === tenantId
    })

    if (optionsTemplate) {
      this.agencySelectTarget.innerHTML = optionsTemplate.innerHTML
      this.agencySelectTarget.disabled = false
      this.agencySelectTarget.value = ""
      this.agencyGroupTarget.classList.remove("d-none")
    } else {
      this.agencyGroupTarget.classList.add("d-none")
      this.agencySelectTarget.disabled = true
    }
  }
}
